var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/upload-button.tsx";
import React, { useRef } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { IconButton } from 'soapbox/components/ui';
import { useAppSelector } from 'soapbox/hooks';
const messages = defineMessages({
  upload: {
    "id": "upload_button.label",
    "defaultMessage": "Add media attachment"
  }
});

const onlyImages = types => {
  return Boolean(types && types.every(type => type.startsWith('image/')));
};

const UploadButton = _ref => {
  let {
    disabled = false,
    unavailable = false,
    onSelectFile,
    resetFileKey
  } = _ref;
  const intl = useIntl();
  const fileElement = useRef(null);
  const attachmentTypes = useAppSelector(state => state.instance.configuration.getIn(['media_attachments', 'supported_mime_types']));

  const handleChange = e => {
    var _e$target$files;

    if ((_e$target$files = e.target.files) !== null && _e$target$files !== void 0 && _e$target$files.length) {
      onSelectFile(e.target.files, intl);
    }
  };

  const handleClick = () => {
    var _fileElement$current;

    (_fileElement$current = fileElement.current) === null || _fileElement$current === void 0 ? void 0 : _fileElement$current.click();
  };

  if (unavailable) {
    return null;
  }

  const src = onlyImages(attachmentTypes) ? require('@tabler/icons/photo.svg') : require('@tabler/icons/paperclip.svg');
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    src: src,
    className: "text-gray-600 hover:text-gray-700 dark:hover:text-gray-500",
    title: intl.formatMessage(messages.upload),
    disabled: disabled,
    onClick: handleClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("label", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 9
    }
  }, intl.formatMessage(messages.upload)), /*#__PURE__*/React.createElement("input", {
    key: resetFileKey,
    ref: fileElement,
    type: "file",
    multiple: true,
    accept: attachmentTypes && attachmentTypes.toArray().join(','),
    onChange: handleChange,
    disabled: disabled,
    className: "hidden",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 9
    }
  })));
};

export default UploadButton;